import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import parse from "html-react-parser";

function CardVisiMisi() {
  const [titleVisi, setTitleVisi] = useState("");
  const [visi, setVisi] = useState("");

  const [misiList, setMisiList] = useState([]);

  // Fetch data Misi
  useEffect(() => {
    const fetchMisiList = async () => {
      try {
        const response = await axios.get("/api_w/abouts?title=Misi", {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });

        setMisiList(response.data.data || []);
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
      }
    };

    fetchMisiList();
  }, []);

  // Fetch data Visi
  useEffect(() => {
    const fetchData = async () => {
      try {
        const vision = await axios.get("/api_w/abouts?title=Visi", {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });

        const visiData = vision.data.data?.[0];

        setTitleVisi(visiData?.title || "Visi");
        setVisi(visiData?.body || "");
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
      }
    };

    fetchData();
  }, []);


  const splitMisi = (body) => {
    if (!body) return [];


    const plainText = body
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    const result = plainText
      .split(/(?=\d+\.\s)/)
      .map((item) => item.trim())
      .filter(Boolean)
      .map((item) => item.replace(/^\d+\.\s*/, "").trim());

    return result;
  };

  return (
    <div className="mb-8 space-y-6">
      {/* ===================== */}
      {/* VISI */}
      {/* ===================== */}
      <div className="group overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm transition-all duration-500 hover:border-green-200 hover:shadow-xl">
        <div className="p-6 md:p-8">
          <h2 className="mb-4 text-xl font-bold leading-tight text-gray-800 md:text-2xl">
            {titleVisi || "Visi"}
          </h2>

          <div className="text-sm leading-relaxed text-gray-600 md:text-base">
            {visi ? parse(visi) : "Visi"}
          </div>
        </div>
      </div>

      {/* ===================== */}
      {/* MISI */}
      {/* ===================== */}
      <div className="group overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm transition-all duration-500 hover:border-green-200 hover:shadow-xl">
        <div className="p-6 md:p-8">
          <h2 className="mb-5 text-xl font-bold leading-tight text-gray-800 md:text-2xl">
            Misi
          </h2>

          <div className="flex flex-col gap-4">
            {misiList.length > 0 ? (
              misiList.map((item, index) => {
                const listMisi = splitMisi(item.body);

                return listMisi.map((misi, misiIndex) => (
                  <div
                    key={`${item.id || index}-${misiIndex}`}
                    className="flex w-full items-start gap-4 rounded-xl border border-gray-100 bg-gray-50 p-4 transition-all duration-300 hover:border-green-200 hover:bg-green-50"
                  >
                    {/* NOMOR MISI */}
                    <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-green-600 text-sm font-bold text-white">
                      {misiIndex + 1}
                    </div>

                    {/* DESKRIPSI MISI */}
                    <div className="min-w-0 flex-1 text-sm leading-relaxed text-gray-600 md:text-base">
                      {misi}
                    </div>
                  </div>
                ));
              })
            ) : (
              <p className="text-sm text-gray-500">
                Tidak ada data misi.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardVisiMisi;